module.exports = __webpack_public_path__ + "static/media/maintenance-mobile.861097bc.png";